import {
	ADYEN_APPLE_PAY_POPUP,
	ADYEN_GOOGLE_PAY_POPUP, CANCEL_ADYEN_APPLE_PAY_POPUP,
	CANCEL_ADYEN_GOOGLE_PAY_POPUP, CANCEL_APPLE_PAY_CHECK_PAYMENT_STATUS_ERROR_MESSAGE,
	CANCEL_BIRTHDAY,
	CANCEL_CARD_PAYMENT_WARNING_MESSAGE,
	CANCEL_CARD_STATUS,
	CANCEL_CART_MODIFIER_GROUP_EDIT,
	CANCEL_CASHPOINTS, CANCEL_CONFIRM_GUEST_ORDER_POPUP,
	CANCEL_DEBUG,
	CANCEL_DELIVERY_ADDRESS,
	CANCEL_DISCOUNT_ERROR_MESSAGE,
	CANCEL_EMAIL,
	CANCEL_EMAIL_ALL_RECEIPTS,
	CANCEL_EMAIL_RECEIPT, CANCEL_GOOGLE_PAY_CHECK_PAYMENT_STATUS_ERROR_MESSAGE, CANCEL_GUEST_ORDER_POPUP,
	CANCEL_INCOMPATIBLE_CART_CONFIRMATION,
	CANCEL_INITIAL, CANCEL_INITIAL_ORDER_POPUP,
	CANCEL_LOCATION_PERMISSION_CONFIRMATION,
	CANCEL_LOGOUT_CONFIRMATION,
	CANCEL_MINICART, CANCEL_MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE,
	CANCEL_MODIFIER_GROUP_EDIT,
	CANCEL_MODIFIERS_VALIDATION_ERROR_MESSAGE,
	CANCEL_NAME,
	CANCEL_NOTIFICATIONS,
	CANCEL_OFFERS,
	CANCEL_ORDERS,
	CANCEL_PHONE,
	CANCEL_PICKUP_WARNING_MESSAGE,
	CANCEL_PROFILE,
	CANCEL_PROFILE_STRIPE_CARD_REGISTRATION,
	CANCEL_PROMOCODE,
	CANCEL_RESEND_VERIFICATION_CODE_MESSAGE,
	CANCEL_RESTAURANT_CLOSED_ERROR_MESSAGE,
	CANCEL_SELECT_LANGUAGE,
	CANCEL_SELECT_LOCATION,
	CANCEL_SEND_ORDER_ERROR_MESSAGE,
	CANCEL_SETTINGS,
	CANCEL_STRIPE_CARD_REGISTRATION, CANCEL_STRIPE_THREE_DS_POPUP,
	CANCEL_TABLE_EDIT,
	CANCEL_TERMS,
	CANCEL_VERIFICATION_CODE,
	CANCEL_VIPPS_ERROR,
	CANCEL_VIPPS_ERROR_MESSAGE,
	CANCEL_VIPPS_PAYMENT_FRAME,
	CANCEL_ZIP_EDIT, CHECK_DELIVERY_ADDRESS, CONFIRM_GUEST_ORDER_POPUP,
	CONFIRM_VERIFICATION_CODE_RESEND,
	DONE_BIRTHDAY,
	DONE_CARD_PAYMENT_WARNING_MESSAGE,
	DONE_CARD_STATUS,
	DONE_DELIVERY_ADDRESS,
	DONE_EMAIL,
	DONE_EMAIL_ALL_RECEIPTS,
	DONE_EMAIL_RECEIPT,
	DONE_INCOMPATIBLE_CART_CONFIRMATION,
	DONE_LOCATION_PERMISSION_CONFIRMATION,
	DONE_LOGOUT_CONFIRMATION,
	DONE_NAME,
	DONE_OFFERS,
	DONE_PICKUP_WARNING_MESSAGE,
	DONE_PROMOCODE,
	DONE_SELECT_LANGUAGE,
	DONE_TABLE_EDIT,
	DONE_TERMS,
	DONE_ZIP_EDIT, GUEST_ORDER_POPUP,
	OPEN_BIRTHDAY,
	OPEN_CARD_STATUS,
	OPEN_CART_MODIFIER_GROUP_EDIT,
	OPEN_CASHPOINTS,
	OPEN_DEBUG,
	OPEN_DELETE_CARD,
	OPEN_DELIVERY_ADDRESS,
	OPEN_EMAIL,
	OPEN_EMAIL_ALL_RECEIPTS,
	OPEN_EMAIL_RECEIPT,
	OPEN_INCOMPATIBLE_CART_CONFIRMATION,
	OPEN_INITIAL,
	OPEN_LOCATION_PERMISSION_CONFIRMATION,
	OPEN_LOGOUT_CONFIRMATION,
	OPEN_MINICART,
	OPEN_MODIFIER_GROUP_EDIT,
	OPEN_NAME,
	OPEN_NOTIFICATIONS,
	OPEN_OFFERS,
	OPEN_ORDERS,
	OPEN_PHONE,
	OPEN_PROFILE,
	OPEN_PROMOCODE,
	OPEN_REGISTRATION_POPUP,
	OPEN_SELECT_LANGUAGE,
	OPEN_SELECT_LOCATION,
	OPEN_SETTINGS,
	OPEN_TABLE_EDIT,
	OPEN_TABLE_NUMBER, STRIPE_THREE_DS_POPUP,
} from 'new-constants/popup.constants';
import {SELECT_LOCATION_POPUP} from 'new-components/popups/select-location/SelectLocation';
import {MINICART_POPUP} from 'compositions/minicart/Minicart';
import {PHONE_POPUP} from 'new-components/popups/phone/Phone';
import {VERIFICATION_CODE_POPUP} from 'new-components/popups/verification-code/VerificationCode';
import {ORDERS_POPUP} from 'new-components/popups/orders/Orders';
import {PROFILE_POPUP} from 'new-components/popups/profile/Profile';
import {SETTINGS_POPUP} from 'new-components/popups/settings/Settings';
import {NAME_POPUP} from 'new-components/popups/name/Name';
import {EMAIL_POPUP} from 'new-components/popups/email/Email';
import {BIRTHDAY_POPUP} from 'new-components/popups/birthday/Birthday';
import {OFFERS_POPUP} from 'new-components/popups/offers/Offers';
import {CASHPOINTS_POPUP} from 'new-components/popups/cashpoints/Cashpoints';
import {SELECT_LANGUAGE_POPUP} from 'new-components/popups/select-language/SelectLanguage';
import {INITIAL_POPUP} from 'new-components/popups/initial/Initial';
import {
	CART_MODIFIER_GROUP_EDIT_POPUP,
	MODIFIER_GROUP_EDIT_POPUP,
} from 'new-components/popups/modifier-group-edit/ModifierGroupEdit';
import {
	PROFILE_STRIPE_CARD_REGISTRATION_POPUP,
	STRIPE_CARD_REGISTRATION_POPUP,
} from 'new-components/popups/stripe-card-registration/StripeCardRegistration';
import {DELIVERY_ADDRESS_POPUP} from 'new-components/popups/delivery-address/DeliveryAddress';
import {PROMOCODE_EDIT_POPUP, PROMOCODE_POPUP} from 'new-components/popups/promocode-edit/PromocodeEdit';
import {TABLE_EDIT_POPUP} from 'new-components/popups/table-edit/TableEdit';
import {VIPPS_PAYMENT_FRAME_POPUP} from 'new-components/popups/vipps-payment-frame/VippsPaymentFrame';
import {
	APPLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP,
	DISCOUNT_ERROR_MESSAGE_POPUP,
	GOOGLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP,
	MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE_POPUP,
	RESTAURANT_CLOSED_ERROR_MESSAGE_POPUP,
	SEND_ORDER_ERROR_MESSAGE_POPUP,
	VIPPS_ERROR_MESSAGE_POPUP,
} from 'new-components/popups/error-message/ErrorMessage';
import {ZIP_EDIT_POPUP} from 'new-components/popups/zip-edit/ZipEdit';
import {
	CHECK_PHONE_CODE,
	RESEND_PHONE_CODE,
	SEND_ORDER,
	SET_BIRTHDATE,
	SET_EMAIL,
	SET_NAME,
	SET_PHONE,
} from 'new-constants/api.constants';
import {
	CARD_PAYMENT_CONFIRMATION_POPUP,
	INCOMPATIBLE_CART_CONFIRMATION_POPUP,
	LOCATION_PERMISSION_CONFIRMATION_POPUP,
	LOGOUT_CONFIRMATION_POPUP,
	PICKUP_CONFIRMATION_POPUP,
} from 'new-components/popups/confirmation/Confirmation';
import {EMAIL_ALL_RECEIPTS_POPUP, EMAIL_RECEIPT_POPUP} from 'new-components/popups/email-receipt/EmailReceipt';
import {ADD_MENU_ENTRY_TO_CART} from 'new-constants/order-line.constants';
import {NOTIFICATIONS_POPUP} from 'new-components/popups/notifications/Notifications';
import {CARD_STATUS_POPUP} from 'new-components/popups/card-status/CardStatus';
import {DEBUG_POPUP} from 'new-components/popups/debug/Debug';
import {TERMS_POPUP} from 'new-components/popups/terms/Terms';
import {
	ADYEN_CARD_REGISTRATION_POPUP,
	CACNEL_ADYEN_CARD_CHECK_PAYMENT_ERROR_MESSAGE_POPUP,
	CANCEL_ADD_TO_HOME_SCREEN,
	CANCEL_ADYEN_CARD_REGISTRATION_POPUP,
	CANCEL_CUSTOM_PAYMENT_TYPE_WARNING_MESSAGE,
	CANCEL_DELIVERY_ADDRESS_FROM_CART,
	CANCEL_MOBILE_PAY_INIT_ERROR_MESSAGE,
	CANCEL_MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE,
	CANCEL_MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE,
	CANCEL_REPEAT_ORDER_CONFIRMATION,
	CANCEL_REPEAT_ORDER_ERROR_MESSAGE,
	CANCEL_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION,
	CANCEL_REPEAT_ORDER_MESSAGE,
	CANCEL_REPEAT_ORDER_MESSAGE_FROM_CART,
	CANCEL_SELECT_LOCATION_FROM_CART,
	CANCEL_SWISH_PAY_CHECK_PAYMENT_STATUS_ERROR_MESSAGE,
	CANCEL_SWISH_PAY_POPUP,
	CANCEL_ZIP_EDIT_FROM_CART,
	CAUTH_CLEAR_CUSTOMER_DATA_POPUP,
	DONE_ADD_TO_HOME_SCREEN,
	DONE_CUSTOM_PAYMENT_TYPE_WARNING_MESSAGE,
	DONE_DELIVERY_ADDRESS_FROM_CART,
	DONE_MOBILE_OAY_ANONYMOUS_INFO,
	DONE_MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE,
	DONE_REPEAT_ORDER_CONFIRMATION,
	DONE_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION,
	DONE_SERVER, DONE_SLOW_SERVICE_CAPTION,
	DONE_ZIP_EDIT_FROM_CART,
	OPEN_ADD_TO_HOME_SCREEN,
	OPEN_DELIVERY_ADDRESS_FROM_CART,
	OPEN_MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE,
	OPEN_REPEAT_ORDER_CONFIRMATION,
	OPEN_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION,
	PROFILE_ADYEN_CARD_REGISTRATION_POPUP,
	SLOW_SERVICE_POPUP,
	SWISH_PAY_POPUP
} from "../constants/popup.constants";
import {ADD_TO_HOME_SCREEN_POPUP} from "../components/popups/add-to-home-screen/AddToHomeScreen";
import {
	CUSTOM_PAYMENT_TYPE_CONFIRMATION_POPUP,
	REPEAT_ORDER_CONFIRMATION_POPUP, REPEAT_ORDER_FROM_HISTORY_CONFIRMATION_POPUP
} from "../components/popups/confirmation/Confirmation";
import {REGISTER_ADYEN_CARD, REPEAT_ORDER} from "../constants/api.constants";
import {CART_DELIVERY_ADDRESS_POPUP} from "../components/popups/delivery-address/DeliveryAddress";
import {CART_ZIP_EDIT_POPUP} from "../components/popups/zip-edit/ZipEdit";
import {CART_SELECT_LOCATION_POPUP} from "../components/popups/select-location/SelectLocation";
import {
	ADYEN_CARD_PAYMENT_ERROR_MESSAGE_POPUP,
	MOBILE_PAY_INIT_ERROR_MESSAGE_POPUP,
	MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE_POPUP,
	MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE_POPUP,
	MODIFIERS_VALIDATION_ERROR_MESSAGE_POPUP,
	REPEAT_ORDER_ERROR_MESSAGE_POPUP,
	SWISH_PAYMENT_ERROR_MESSAGE_POPUP
} from "../components/popups/error-message/ErrorMessage";
import {trackEvent} from "../helpers/tracking.helpers";
import {PaymentTypes} from "../constants/common.constants";
import {ADYEN_MOBILE_PAY_ANONYMOUS_INFO_POPUP} from "../components/popups/adyen-mobile-pay-anonymous-info/AdyenMobilePayAnonymousInfo";
import {MOBILE_PAY_FORM_POPUP} from "new-components/popups/mobile-pay-form/MobilePayForm";
import {INITIAL_ORDER_POPUP} from "new-components/popups/inital-order-popup/InitialOrderPopup";

export const openSelectLocation = () => ({
	type: OPEN_SELECT_LOCATION,
	showPopup: SELECT_LOCATION_POPUP,
});

export const cancelSelectLocation = () => ({
	type: CANCEL_SELECT_LOCATION,
	hidePopups: [SELECT_LOCATION_POPUP],
});

export const cancelSelectLocationFromCart = () => ({
	type: CANCEL_SELECT_LOCATION_FROM_CART,
	hidePopups: [CART_SELECT_LOCATION_POPUP],
});

export const openMinicart = () => ({
	type: OPEN_MINICART,
	showPopup: MINICART_POPUP,
});

export const cancelMinicart = () => ({
	type: CANCEL_MINICART,
	hidePopups: [MINICART_POPUP],
});

export const openPhone = () => ({
	type: OPEN_PHONE,
	showPopup: PHONE_POPUP,
	dismissError: SET_PHONE,
});

export const cancelPhone = () => ({
	type: CANCEL_PHONE,
	hidePopups: [PHONE_POPUP],
});

export const cancelVerificationCode = () => ({
	type: CANCEL_VERIFICATION_CODE,
	hidePopups: [VERIFICATION_CODE_POPUP],
	dismissError: CHECK_PHONE_CODE,
});

export const confirmVerificationCodeResend = () => ({
	type: CONFIRM_VERIFICATION_CODE_RESEND,
});

export const openOrders = () => ({
	type: OPEN_ORDERS,
	showPopup: ORDERS_POPUP,
});

export const cancelOrders = () => ({
	type: CANCEL_ORDERS,
	hidePopups: [ORDERS_POPUP],
});

export const openProfile = () => ({
	type: OPEN_PROFILE,
	showPopup: PROFILE_POPUP,
});

export const cancelProfile = () => ({
	type: CANCEL_PROFILE,
	hidePopups: [PROFILE_POPUP],
});

export const openSettings = () => ({
	type: OPEN_SETTINGS,
	showPopup: SETTINGS_POPUP,
});

export const cancelSettings = () => ({
	type: CANCEL_SETTINGS,
	hidePopups: [SETTINGS_POPUP],
});

export const openName = () => ({
	type: OPEN_NAME,
	showPopup: NAME_POPUP,
	dismissError: SET_NAME,
});

export const cancelName = () => ({
	type: CANCEL_NAME,
	hidePopups: [NAME_POPUP],
});

export const doneName = name => ({
	type: DONE_NAME,
	name,
});

export const openEmail = () => ({
	type: OPEN_EMAIL,
	showPopup: EMAIL_POPUP,
	dismissError: SET_EMAIL,
});

export const cancelEmail = () => ({
	type: CANCEL_EMAIL,
	hidePopups: [EMAIL_POPUP],
});

export const doneEmail = email => ({
	type: DONE_EMAIL,
	email,
});

export const openBirthday = () => ({
	type: OPEN_BIRTHDAY,
	showPopup: BIRTHDAY_POPUP,
	dismissError: SET_BIRTHDATE,
});

export const cancelBirthday = () => ({
	type: CANCEL_BIRTHDAY,
	hidePopups: [BIRTHDAY_POPUP],
});

export const doneBirthday = birthday => ({
	type: DONE_BIRTHDAY,
	birthday,
});

export const openOffers = () => ({
	type: OPEN_OFFERS,
	showPopup: OFFERS_POPUP,
});

export const cancelOffers = () => ({
	type: CANCEL_OFFERS,
	hidePopups: [OFFERS_POPUP],
});

export const openCashpoints = () => ({
	type: OPEN_CASHPOINTS,
	showPopup: CASHPOINTS_POPUP,
});

export const cancelCashpoints = () => ({
	type: CANCEL_CASHPOINTS,
	hidePopups: [CASHPOINTS_POPUP],
});

export const openSelectLanguage = () => ({
	type: OPEN_SELECT_LANGUAGE,
	showPopup: SELECT_LANGUAGE_POPUP,
});

export const cancelSelectLanguage = () => ({
	type: CANCEL_SELECT_LANGUAGE,
	hidePopups: [SELECT_LANGUAGE_POPUP],
});

export const doneSelectLanguage = language => ({
	type: DONE_SELECT_LANGUAGE,
	hidePopups: [SELECT_LANGUAGE_POPUP],
	language,
});

export const openInitial = () => ({
	type: OPEN_INITIAL,
	showPopup: INITIAL_POPUP,
});

export const cancelInitial = () => ({
	type: CANCEL_INITIAL,
	hidePopups: [INITIAL_POPUP],
});

export const openModifierGroupEdit = () => ({
	type: OPEN_MODIFIER_GROUP_EDIT,
	showPopup: MODIFIER_GROUP_EDIT_POPUP,
});

export const cancelModifierGroupEdit = () => ({
	type: CANCEL_MODIFIER_GROUP_EDIT,
	hidePopups: [MODIFIER_GROUP_EDIT_POPUP],
});

export const openCartModifierGroupEdit = () => ({
	type: OPEN_CART_MODIFIER_GROUP_EDIT,
	showPopup: CART_MODIFIER_GROUP_EDIT_POPUP,
});

export const cancelCartModifierGroupEdit = () => ({
	type: CANCEL_CART_MODIFIER_GROUP_EDIT,
	hidePopups: [CART_MODIFIER_GROUP_EDIT_POPUP],
});

export const cancelStripeCardRegistration = () => ({
	type: CANCEL_STRIPE_CARD_REGISTRATION,
	hidePopups: [STRIPE_CARD_REGISTRATION_POPUP],
});

export const cancelProfileStripeCardRegistration = () => ({
	type: CANCEL_PROFILE_STRIPE_CARD_REGISTRATION,
	hidePopups: [PROFILE_STRIPE_CARD_REGISTRATION_POPUP],
});

export const cancelVippsPaymentFrame = () => ({
	type: CANCEL_VIPPS_PAYMENT_FRAME,
	hidePopups: [VIPPS_PAYMENT_FRAME_POPUP],
});

export const openDeliveryAddress = () => ({
	type: OPEN_DELIVERY_ADDRESS,
	showPopup: DELIVERY_ADDRESS_POPUP,
});

export const cancelDeliveryAddress = () => ({
	type: CANCEL_DELIVERY_ADDRESS,
	hidePopups: [DELIVERY_ADDRESS_POPUP],
});

export const doneDeliveryAddress = (address, zip, location, predictionId, isCheckDeliveryAddress) => ({
	type: DONE_DELIVERY_ADDRESS,
	showPopup: zip ? null : ZIP_EDIT_POPUP,
	address,
	zip,
	location,
	predictionId,
	isCheckDeliveryAddress
});

export const openDeliveryAddressFromCart = () => ({
	type: OPEN_DELIVERY_ADDRESS_FROM_CART,
	showPopup: CART_DELIVERY_ADDRESS_POPUP,
});

export const cancelDeliveryAddressFromCart = () => ({
	type: CANCEL_DELIVERY_ADDRESS_FROM_CART,
	hidePopups: [CART_DELIVERY_ADDRESS_POPUP],
});

export const doneDeliveryAddressFromCart = (address, zip, location, predictionId, isCheckDeliveryAddress) => ({
	type: DONE_DELIVERY_ADDRESS_FROM_CART,
	showPopup: zip ? null : CART_ZIP_EDIT_POPUP,
	address,
	zip,
	location,
	predictionId,
	isCheckDeliveryAddress
});

export const openPromocode = () => ({
	type: OPEN_PROMOCODE,
	showPopup: PROMOCODE_EDIT_POPUP,
});

export const cancelPromocode = () => ({
	type: CANCEL_PROMOCODE,
	hidePopups: [PROMOCODE_EDIT_POPUP],
});

export const donePromocode = promocode => ({
	type: DONE_PROMOCODE,
	promocode,
});

export const openTableEdit = () => ({
	type: OPEN_TABLE_EDIT,
	showPopup: TABLE_EDIT_POPUP,
});

export const cancelTableEdit = () => ({
	type: CANCEL_TABLE_EDIT,
	hidePopups: [TABLE_EDIT_POPUP],
});

export const doneTableEdit = tableNumber => ({
	type: DONE_TABLE_EDIT,
	tableNumber,
});

export const cancelVippsErrorMessage = () => ({
	type: CANCEL_VIPPS_ERROR_MESSAGE,
	hidePopups: [VIPPS_ERROR_MESSAGE_POPUP],
});

export const cancelDiscountErrorMessage = () => ({
	type: CANCEL_DISCOUNT_ERROR_MESSAGE,
	hidePopups: [DISCOUNT_ERROR_MESSAGE_POPUP],
});

export const cancelZipEdit = () => ({
	type: CANCEL_ZIP_EDIT,
	hidePopups: [ZIP_EDIT_POPUP],
});

export const doneZipEdit = zip => ({
	type: DONE_ZIP_EDIT,
	zip,
});

export const cancelZipEditFromCart = () => ({
	type: CANCEL_ZIP_EDIT_FROM_CART,
	hidePopups: [CART_ZIP_EDIT_POPUP],
});

export const doneZipEditFromCart = zip => ({
	type: DONE_ZIP_EDIT_FROM_CART,
	zip,
});

export const openDeleteCard = () => ({
	type: OPEN_DELETE_CARD,
});

export const cancelPickupWarningMessage = () => ({
	type: CANCEL_PICKUP_WARNING_MESSAGE,
	hidePopups: [PICKUP_CONFIRMATION_POPUP],
});

export const donePickupWarningMessage = () => ({
	type: DONE_PICKUP_WARNING_MESSAGE,
	hidePopups: [PICKUP_CONFIRMATION_POPUP],
});

export const cancelCardPaymentWarningMessage = (restaurantId) => {
	trackEvent({
		event: 'Cancel Card Payment Warning Message',
		properties: {
			'Venue Id': restaurantId,
		}
	});
	
	return {
		type: CANCEL_CARD_PAYMENT_WARNING_MESSAGE,
		hidePopups: [CARD_PAYMENT_CONFIRMATION_POPUP],
	}
};

export const doneCardPaymentWarningMessage = (restaurantId) => {
	trackEvent({
		event: 'Done Card Payment Warning Message',
		properties: {
			'Venue Id': restaurantId,
		}
	});
	return {
		type: DONE_CARD_PAYMENT_WARNING_MESSAGE,
		hidePopups: [CARD_PAYMENT_CONFIRMATION_POPUP],
	}
};

export const cancelRestaurantClosedErrorMessage = () => ({
	type: CANCEL_RESTAURANT_CLOSED_ERROR_MESSAGE,
	hidePopups: [RESTAURANT_CLOSED_ERROR_MESSAGE_POPUP],
});

export const openLogoutConfirmation = () => ({
	type: OPEN_LOGOUT_CONFIRMATION,
	showPopup: LOGOUT_CONFIRMATION_POPUP,
});

export const cancelLogoutConfirmation = () => ({
	type: CANCEL_LOGOUT_CONFIRMATION,
	hidePopups: [LOGOUT_CONFIRMATION_POPUP],
});

export const doneLogoutConfirmation = () => ({
	type: DONE_LOGOUT_CONFIRMATION,
	hidePopups: [LOGOUT_CONFIRMATION_POPUP],
});

export const openEmailReceipt = () => ({
	type: OPEN_EMAIL_RECEIPT,
	showPopup: EMAIL_RECEIPT_POPUP,
});

export const cancelEmailReceipt = () => ({
	type: CANCEL_EMAIL_RECEIPT,
	hidePopups: [EMAIL_RECEIPT_POPUP],
});

export const doneEmailReceipt = (orderId, email, isSubscribe) => ({
	type: DONE_EMAIL_RECEIPT,
	orderId,
	email,
	isSubscribe
});

export const openEmailAllReceipts = () => ({
	type: OPEN_EMAIL_ALL_RECEIPTS,
	showPopup: EMAIL_ALL_RECEIPTS_POPUP,
});

export const cancelEmailAllReceipts = () => ({
	type: CANCEL_EMAIL_ALL_RECEIPTS,
	hidePopups: [EMAIL_ALL_RECEIPTS_POPUP],
});

export const doneEmailAllReceipts = (email, isSubscribe) => ({
	type: DONE_EMAIL_ALL_RECEIPTS,
	email,
	isSubscribe,
});

export const cancelResendVerificationCodeMessage = () => ({
	type: CANCEL_RESEND_VERIFICATION_CODE_MESSAGE,
	dismissMessage: RESEND_PHONE_CODE,
});

export const cancelModifiersValidationErrorMessage = () => ({
	type: CANCEL_MODIFIERS_VALIDATION_ERROR_MESSAGE,
	hidePopups: [MODIFIERS_VALIDATION_ERROR_MESSAGE_POPUP],
	dismissError: ADD_MENU_ENTRY_TO_CART,
});

export const openNotifications = () => ({
	type: OPEN_NOTIFICATIONS,
	showPopup: NOTIFICATIONS_POPUP,
});

export const cancelNotifications = () => ({
	type: CANCEL_NOTIFICATIONS,
	hidePopups: [NOTIFICATIONS_POPUP],
});

export const openRegistrationPopup = (registrationPopup, restaurantId) => ({
	type: OPEN_REGISTRATION_POPUP,
	showPopup: registrationPopup,
	restaurantId,
});

export const openCardStatus = (currentCardNumber, paymentTypes) => {
	return {
		type: OPEN_CARD_STATUS,
		showPopup: currentCardNumber ? CARD_STATUS_POPUP : paymentTypes.indexOf(PaymentTypes.payWithAdyenCard) >= 0 ? ADYEN_CARD_REGISTRATION_POPUP
			: PROFILE_STRIPE_CARD_REGISTRATION_POPUP,
	}
}

export const cancelCardStatus = () => ({
	type: CANCEL_CARD_STATUS,
	hidePopups: [CARD_STATUS_POPUP],
});

export const doneCardStatus = (paymentTypes) => ({
	type: DONE_CARD_STATUS,
	hidePopups: [CARD_STATUS_POPUP],
	showPopup: paymentTypes.indexOf(PaymentTypes.payWithAdyenCard) >= 0 ? ADYEN_CARD_REGISTRATION_POPUP : PROFILE_STRIPE_CARD_REGISTRATION_POPUP
});

export const openDebug = () => ({
	type: OPEN_DEBUG,
	showPopup: DEBUG_POPUP,
});

export const cancelDebug = () => ({
	type: CANCEL_DEBUG,
	hidePopups: [DEBUG_POPUP],
});

export const openIncompatibleCartConfirmation = () => ({
	type: OPEN_INCOMPATIBLE_CART_CONFIRMATION,
	showPopup: INCOMPATIBLE_CART_CONFIRMATION_POPUP,
});

export const cancelIncompatibleCartConfirmation = () => ({
	type: CANCEL_INCOMPATIBLE_CART_CONFIRMATION,
	hidePopups: [INCOMPATIBLE_CART_CONFIRMATION_POPUP],
});

export const doneIncompatibleCartConfirmation = restaurantId => ({
	type: DONE_INCOMPATIBLE_CART_CONFIRMATION,
	hidePopups: [INCOMPATIBLE_CART_CONFIRMATION_POPUP],
	restaurantId,
});

export const cancelSendOrderErrorMessage = () => ({
	type: CANCEL_SEND_ORDER_ERROR_MESSAGE,
	hidePopups: [SEND_ORDER_ERROR_MESSAGE_POPUP],
	dismissError: SEND_ORDER,
});

export const cancelTerms = () => ({
	type: CANCEL_TERMS,
	hidePopups: [TERMS_POPUP],
});

export const doneTerms = (termsConsent, marketingConsent) => ({
	type: DONE_TERMS,
	termsConsent,
	marketingConsent,
});

export const openLocationPermissionConfirmation = () => ({
	type: OPEN_LOCATION_PERMISSION_CONFIRMATION,
	showPopup: LOCATION_PERMISSION_CONFIRMATION_POPUP,
});

export const cancelLocationPermissionConfirmation = () => ({
	type: CANCEL_LOCATION_PERMISSION_CONFIRMATION,
	hidePopups: [LOCATION_PERMISSION_CONFIRMATION_POPUP],
});

export const doneLocationPermissionConfirmation = () => ({
	type: DONE_LOCATION_PERMISSION_CONFIRMATION,
});

export const openAddToHomeScreen = () => ({
	type: OPEN_ADD_TO_HOME_SCREEN,
	showPopup: ADD_TO_HOME_SCREEN_POPUP
});

export const cancelAddToHomeScreen = () => ({
	type: CANCEL_ADD_TO_HOME_SCREEN,
	hidePopups: [ADD_TO_HOME_SCREEN_POPUP]
});

export const doneAddToHomeScreen = () => ({
	type: DONE_ADD_TO_HOME_SCREEN,
});

export const cancelCustomPaymentTypeWarningMessage = () => ({
	type: CANCEL_CUSTOM_PAYMENT_TYPE_WARNING_MESSAGE,
	hidePopups: [CUSTOM_PAYMENT_TYPE_CONFIRMATION_POPUP],
});

export const doneCustomPaymentTypeWarningMessage = () => ({
	type: DONE_CUSTOM_PAYMENT_TYPE_WARNING_MESSAGE,
	hidePopups: [CUSTOM_PAYMENT_TYPE_CONFIRMATION_POPUP],
});

export const doneServerPopup = (popupId) => ({
	type: DONE_SERVER,
	popupId,
});

export const openRepeatOrderConfirmation = () => ({
	type: OPEN_REPEAT_ORDER_CONFIRMATION,
	showPopup: REPEAT_ORDER_CONFIRMATION_POPUP
});

export const cancelRepeatOrderConfirmation = () => ({
	type: CANCEL_REPEAT_ORDER_CONFIRMATION,
	hidePopups: [REPEAT_ORDER_CONFIRMATION_POPUP]
});

export const doneRepeatOrderConfirmation = orderId => {
	trackEvent({
		event: 'Done Repeat Order ConfirmGuestOrderPopup',
		properties: {
			'Order Id': orderId,
		}
	});
	return {
		type: DONE_REPEAT_ORDER_CONFIRMATION,
		orderId
	}
};

export const openRepeatOrderFromHistoryConfirmation = () => {
	trackEvent({
		event: 'Open Repeat Order From History ConfirmGuestOrderPopup',
		properties: {}
	});
	return {
		type: OPEN_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION,
		showPopup: REPEAT_ORDER_FROM_HISTORY_CONFIRMATION_POPUP
	}
};

export const cancelRepeatOrderFromHistoryConfirmation = () => {
	trackEvent({
		event: 'Cancel Repeat Order From History ConfirmGuestOrderPopup',
		properties: {}
	});
	return {
		type: CANCEL_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION,
		hidePopups: [REPEAT_ORDER_FROM_HISTORY_CONFIRMATION_POPUP]
	}
};

export const doneRepeatOrderFromHistoryConfirmation = orderId => {
	trackEvent({
		event: 'Done Repeat Order From History ConfirmGuestOrderPopup',
		properties: {
			'Order Id': orderId,
		}
	});
	return {
		type: DONE_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION,
		orderId
	}
};

export const cancelRepeatOrderMessage = () => ({
	type: CANCEL_REPEAT_ORDER_MESSAGE,
	dismissMessage: REPEAT_ORDER,
});

export const cancelRepeatOrderMessageFromCart = () => ({
	type: CANCEL_REPEAT_ORDER_MESSAGE_FROM_CART,
	dismissMessage: REPEAT_ORDER,
});

export const cancelRepeatOrderErrorMessage = () => ({
	type: CANCEL_REPEAT_ORDER_ERROR_MESSAGE,
	hidePopups: [REPEAT_ORDER_ERROR_MESSAGE_POPUP]
});

export const openMobilePayOrderCancelledErrorMessage = () => ({
	type: OPEN_MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE,
	showPopup: MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE_POPUP
});

export const cancelMobilePayOrderCancelledErrorMessage = () => ({
	type: CANCEL_MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE,
	hidePopups: [MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE_POPUP]
});

export const cancelMobilePayReturnNoStateErrorMessage = () => ({
	type: CANCEL_MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE,
	hidePopups: [MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE_POPUP]
});

export const doneMobilePayReturnNoStateErrorMessage = () => ({
	type: DONE_MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE,
	showPopup: ORDERS_POPUP,
	hidePopups: [MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE_POPUP]
});

export const cancelMobilePayReturnNoUrlErrorMessage = () => {
	return {
		type: CANCEL_MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE,
		hidePopups: [MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE_POPUP]
	}
}

export const cancelAdyenCardCheckPaymentErrorMessagePopup = () => {
	return {
		type: CACNEL_ADYEN_CARD_CHECK_PAYMENT_ERROR_MESSAGE_POPUP,
		hidePopups: [ADYEN_CARD_PAYMENT_ERROR_MESSAGE_POPUP],
		showPopup: INITIAL_POPUP,
	}
}
export const cancelMobilePayInitErrorMessage = () => ({
	type: CANCEL_MOBILE_PAY_INIT_ERROR_MESSAGE,
	hidePopups: [MOBILE_PAY_INIT_ERROR_MESSAGE_POPUP, MOBILE_PAY_FORM_POPUP]
})

export const cancelAdyenCardRegistration = () => ({
	type: CANCEL_ADYEN_CARD_REGISTRATION_POPUP,
	hidePopups: [ADYEN_CARD_REGISTRATION_POPUP],
});

export const cancelSwishPay = () => ({
	type: CANCEL_SWISH_PAY_POPUP,
	hidePopups: [SWISH_PAY_POPUP],
});

export const cancelSwishPayInitErrorMessage = () => ({
	type: CANCEL_SWISH_PAY_CHECK_PAYMENT_STATUS_ERROR_MESSAGE,
	hidePopups: [SWISH_PAYMENT_ERROR_MESSAGE_POPUP]
})

export const doneSlowServiceCaption = () => ({
	type: DONE_SLOW_SERVICE_CAPTION,
	hidePopups: [SLOW_SERVICE_POPUP]
})

export const doneMobilePayAnonymousInfo = () => ({
	type: DONE_MOBILE_OAY_ANONYMOUS_INFO,
	hidePopups: [ADYEN_MOBILE_PAY_ANONYMOUS_INFO_POPUP]
})

export const cancelGooglePayPopup = () => ({
	type: CANCEL_ADYEN_GOOGLE_PAY_POPUP,
	hidePopups: [ADYEN_GOOGLE_PAY_POPUP]
})
export const cancelGooglePayInitErrorMessage = () => ({
	type: CANCEL_GOOGLE_PAY_CHECK_PAYMENT_STATUS_ERROR_MESSAGE,
	hidePopups: [GOOGLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP]
})

export const cancelApplePayPopup = () => ({
	type: CANCEL_ADYEN_APPLE_PAY_POPUP,
	hidePopups: [ADYEN_APPLE_PAY_POPUP]
})

export const cancelApplePayInitErrorMessage = () => ({
	type: CANCEL_APPLE_PAY_CHECK_PAYMENT_STATUS_ERROR_MESSAGE,
	hidePopups: [APPLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP]
})

export const cancelStripeThreeDs = () => ({
	type: CANCEL_STRIPE_THREE_DS_POPUP,
	hidePopups: [STRIPE_THREE_DS_POPUP],
});

export const openGuestOrderPopup = () => ({
	type: GUEST_ORDER_POPUP,
	showPopup: GUEST_ORDER_POPUP,
});

export const cancelGuestOrderPopup = () => ({
	type: CANCEL_GUEST_ORDER_POPUP,
	hidePopups: [GUEST_ORDER_POPUP],
});

export const openInitialOrderPopup = () => ({
	type: INITIAL_ORDER_POPUP,
	showPopup: INITIAL_ORDER_POPUP,
});

export const cancelInitialOrderPopup = () => ({
	type: CANCEL_INITIAL_ORDER_POPUP,
	hidePopups: [INITIAL_ORDER_POPUP],
});

export const openConfirmGuestOrderPopup = () => ({
	type: CONFIRM_GUEST_ORDER_POPUP,
	showPopup: CONFIRM_GUEST_ORDER_POPUP,
});

export const cancelConfirmGuestOrderPopup = () => ({
	type: CANCEL_CONFIRM_GUEST_ORDER_POPUP,
	hidePopups: [CONFIRM_GUEST_ORDER_POPUP],
});
